module.exports = __webpack_public_path__ + "static/media/Untitled_Artwork_6.14a48b71.png";